import { useQuery } from '@tanstack/react-query'
import { shouldUseBillRateKey } from './keys'
import { getShouldUseBillRate, ShouldUseBillRateResponse } from 'api/shift'
import { useAuthContext } from 'components/auth'

const defaultBillRateInfo: ShouldUseBillRateResponse = {
  isBillPay: false,
  blockShiftCreation: false,
}

export function useShouldUseBillRate(positionId?: number) {
  const { company } = useAuthContext()
  return useQuery({
    queryKey: shouldUseBillRateKey(positionId),
    enabled: !!positionId,
    queryFn: () => {
      if (!positionId || !company?.id) {
        return defaultBillRateInfo
      }
      return getShouldUseBillRate({
        companyId: company.id,
        positionId,
      })
    },
  })
}
